import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { EMPTY, map, merge, Subject, switchMap, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AprHistoricalDataModalComponent } from 'app/modules/annulus-pressure-record/components/historical-data-modal/historical-data-modal.component';
import { Router } from '@angular/router';
import module from 'app/modules/annulus-pressure-record/annulus-pressure-record.module';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AprSearchStateService } from '../../state/search.state';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'apr-table',
    templateUrl: './apr-table.component.html',
    standalone: true,
    imports: module,
    styleUrls: ['./apr-table.component.scss'],
})
export class AprTableComponent {
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    @ViewChild(MatSort) private _sort: MatSort;

    @Input() dt: any;
    @Input() startingIndex: number = 0;
    @Input() searchForm: any;

    @Output() setPage = new EventEmitter<object>();
    @Output() onSort = new EventEmitter<MatSort>();

    isLoading: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private dialog: MatDialog,
        public router: Router,
        private _changeDetectorRef: ChangeDetectorRef,
        private state: AprSearchStateService,
    ) {}

    ngAfterViewInit() {
        if (this._sort && this._paginator) {
            // Set the initial sort
            this._sort.sort({
                id: 'field',
                start: 'asc',
                disableClear: true,
            });

            // Mark for check
            this._changeDetectorRef.markForCheck();

            // If the user changes the sort order...
            this._sort.sortChange
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {
                    // Reset back to the first page
                    this._paginator.pageIndex = 0;

                    this.onSort.emit(this._sort);
                });

            // Get platform types if sort or page changes
            merge(this._sort.sortChange, this._paginator.page)
                .pipe(
                    switchMap(() => {
                        // this.isLoading = true;

                        // this.startingIndex = this._paginator.pageIndex * this._paginator.pageSize;

                        let pageInfo = {
                            count: this._paginator.length,
                            pageSize: this._paginator.pageSize,
                            limit: this._paginator.pageSize,
                            offset: this._paginator.pageIndex,
                        };
                        this.setPage.emit(pageInfo); // Emit page number

                        // return this._equipmentService.getEquipmentInventoriesByCompanyId(this.currentCompany.companyId, this._paginator.pageIndex + 1, this._paginator.pageSize, this._sort.active, this._sort.direction);

                        return EMPTY;
                    }),
                    map(() => {
                        this.isLoading = false;
                    }),
                )
                .subscribe();
        }
    }

    openHistoricalModal(wellDetails) {
        const dialogRef = this.dialog.open(AprHistoricalDataModalComponent, {
            data: wellDetails,
            width: '90%',
        });
    }

    editApr(row: any) {
        this.state.set(this.searchForm.value);
        this.router.navigate([
            `/data-management/annulus-pressure-record/${row.id}/edit`,
        ]);
    }

    createApr(row: any) {
        this.state.set(this.searchForm.value);
        this.router.navigate([
            `/data-management/annulus-pressure-record/${row.id}`,
        ]);
    }

    onPage(event: any) {
        this.setPage.emit(event); // Emit page number
    }

    handleFormatDate(dateString: string, withTime) {
        return handleFormatDate(dateString, withTime);
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
